/**
 * Formats a coordinate value to three decimal places
 * @param coordinate - The coordinate value to format
 * @returns Formatted coordinate string with 3 decimal places, or empty string if undefined
 */
export const formatCoordinateToThreeDecimals = (
  coordinate?: number
): string => {
  return coordinate !== undefined ? coordinate.toFixed(3) : "";
};

/**
 * Converts relative coordinates to absolute pixel coordinates and formats them as a string
 * @param relativeX - Relative X coordinate (0-1 range)
 * @param relativeY - Relative Y coordinate (0-1 range)
 * @param imageWidth - Width of the camera image in pixels
 * @param imageHeight - Height of the camera image in pixels
 * @returns Formatted string in the format "X, Y" with 3 decimal places, or empty string if any value is undefined
 */
export const formatAbsoluteCoordinates = (
  relativeX?: number,
  relativeY?: number,
  imageWidth?: number,
  imageHeight?: number
): string => {
  if (!relativeX || !relativeY || !imageWidth || !imageHeight) {
    return "";
  }

  const absoluteX = relativeX * imageWidth;
  const absoluteY = relativeY * imageHeight;

  return `${formatCoordinateToThreeDecimals(absoluteX)}, ${formatCoordinateToThreeDecimals(absoluteY)}`;
};
